import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AUTH_ROUTES } from '@app/shared/utilities/auth-routes';

/** Anonymous registration endpoints: no bearer token, no CompanyCode header (the company does not exist yet). */
const ANONYMOUS = ['admin/ssms/'];

/** Endpoints that handle their own error UI and must not trigger global redirects. */
const LOCALLY_HANDLED = ['admin/ssms/', 'Authentication', 'Face/enrolled-faces'];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Translation files and absolute URLs pass through untouched.
    if (req.url.includes('i18n') || /^https?:\/\//i.test(req.url)) {
      return next.handle(req);
    }

    const path = req.url.startsWith('api/') ? req.url : `api/${req.url}`;
    let newReq = req.clone({ url: `${environment.APPLICATION_BASEURL}${path}` });

    const isAnonymous = ANONYMOUS.some((fragment) => req.url.includes(fragment));
    if (!isAnonymous) {
      const companyCode = localStorage.getItem('companyCode');
      if (companyCode) {
        newReq = newReq.clone({ headers: newReq.headers.set('CompanyCode', companyCode) });
      }
      const token = localStorage.getItem('bearerToken');
      if (token) {
        newReq = newReq.clone({ headers: newReq.headers.set('Authorization', `Bearer ${token}`) });
      }
    }

    return next.handle(newReq).pipe(
      tap({
        error: (err: unknown) => {
          if (!(err instanceof HttpErrorResponse)) {
            return;
          }
          const handledLocally = LOCALLY_HANDLED.some((fragment) => req.url.includes(fragment));

          if (err.status === 401 || err.status === 403) {
            localStorage.removeItem('bearerToken');
            localStorage.removeItem('currentUser');
            if (!handledLocally) {
              this.router.navigate([AUTH_ROUTES.signUp]);
            }
          } else if (err.status === 404 && !handledLocally) {
            this.router.navigate(['/404']);
          }
        }
      })
    );
  }
}
